<div class="main-container" *ngIf="!isLoading" data-cy="claim-validation-detail">
  <div class="section-header" data-cy="claim-validation-detail-header">
    <div class="section-header-title" data-cy="claim-validation-detail-title">Claim Validation</div>
  </div>
  <div *ngIf="this.internalValidation" style="display: flex; height:585px; padding:10px 10px 10px 10px;" data-cy="claim-validation-detail-internal">
    <div style="flex: 5; padding-right: 10px;" data-cy="claim-validation-detail-issues-container">
      <div class="colHeader_fail" data-cy="claim-validation-detail-issues-header">Validation Issues ({{ this.itemsInComplete }})</div>
        <div style="display: flex; height: 500px; overflow-y: auto" data-cy="claim-validation-detail-issues-list">
          <div style="flex: 1" data-cy="claim-validation-detail-issues-content">
            <div *ngFor="let item of this.validationLogItems" style="padding-left: 10px; padding-right: 10px" data-cy="claim-validation-detail-issue-item">
              <div style="display: flex;" data-cy="claim-validation-detail-issue-row">
                <div class="subHeader" style="flex:1" *ngIf="item.ValidationItemType === 0" data-cy="claim-validation-detail-issue-section">
                  {{ item.ValidationItemName }}
                </div>
                <div class="itemIndent" style="flex:1" *ngIf="item.ValidationItemType === 1 && !item.ValidationPass" data-cy="claim-validation-detail-issue-detail">
                  <div style="display: flex" data-cy="claim-validation-detail-issue-content">
                    <div style="flex-basis: 30px" data-cy="claim-validation-detail-issue-icon-container">
                      <mat-icon style="color:#b20a05" data-cy="claim-validation-detail-issue-error-icon">error</mat-icon>
                    </div>

                    <div *ngIf="(item.ValidationHint ? item.ValidationHint : '') != 'showintextarea'" style="flex:2" data-cy="claim-validation-detail-issue-name">
                      {{ item.ValidationItemName }}
                    </div>
                    <div *ngIf="!item.ValidationHint" style="flex:1" data-cy="claim-validation-detail-issue-text">
                      {{ item.ValidationIssue }}
                    </div>
                    <div *ngIf="item.ValidationHint" style="flex:1" matTooltip="{{ item.ValidationHint }}" data-cy="claim-validation-detail-issue-tooltip">
                      {{ item.ValidationIssue }}
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
    <div *ngIf="this.itemsComplete > 0" style="flex: 4" data-cy="claim-validation-detail-completed-container">
      <div class="colHeader_pass" data-cy="claim-validation-detail-completed-header">Completed Items ({{ this.itemsComplete }})</div>
      <div style="display: flex; height: 500px; overflow-y: auto" data-cy="claim-validation-detail-completed-list">
        <div style="flex: 1" data-cy="claim-validation-detail-completed-content">
          <div *ngFor="let item of this.validationLogItems" style="padding-left: 10px; padding-right: 10px" data-cy="claim-validation-detail-completed-item">
            <div style="display: flex;" data-cy="claim-validation-detail-completed-row">
              <div class="subHeader" style="flex:1" *ngIf="item.ValidationItemType === 0" data-cy="claim-validation-detail-completed-section">
                {{ item.ValidationItemName }}
              </div>
              <div class="itemIndent" style="flex:1" *ngIf="item.ValidationItemType === 1 && item.ValidationPass" data-cy="claim-validation-detail-completed-detail">
                <div style="display: flex" data-cy="claim-validation-detail-completed-content">
                  <div style="flex-basis: 30px" data-cy="claim-validation-detail-completed-icon-container">
                    <img src="" data-cy="claim-validation-detail-completed-img">
                    <mat-icon style="color:var(--tdo-purple-light)" data-cy="claim-validation-detail-completed-check-icon">check_circle</mat-icon>
                  </div>
                  <div style="flex:2" data-cy="claim-validation-detail-completed-name">
                    {{ item.ValidationItemName }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="!this.internalValidation" style="display: flex; height:585px; padding:10px 10px 10px 10px;" data-cy="claim-validation-detail-external">
    <app-claim-validation-detail-dxc-parsed [resp]="getDXCResponse()" data-cy="claim-validation-detail-dxc-parsed"></app-claim-validation-detail-dxc-parsed>
  </div>

  <div style="flex: 1; text-align: right; padding-right:10px" data-cy="claim-validation-detail-actions">
    <button style="margin-right: 12px;" class="tdo-button warn" (click)="closeRef()" data-cy="claim-validation-detail-close-btn">Close</button>
  </div>
</div>
<div class="spinner-container" *ngIf="isLoading" data-cy="claim-validation-detail-spinner-container">
  <mat-spinner data-cy="claim-validation-detail-spinner"></mat-spinner>
</div>

